import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {EcuProducersService} from "../service/ecu-producers.service";
import {AbstractControl, FormControl, ValidationErrors, Validators} from "@angular/forms";
import {CorrectEcuProducersModel} from "../models/EcuBuildName-model";

@Component({
    selector: 'app-correct-ecu-producers',
    templateUrl: './correct-ecu-producers.component.html',
    styleUrl: './correct-ecu-producers.component.css'
})
export class CorrectEcuProducersComponent implements OnInit {

    ecuProducersService = inject(EcuProducersService);
    correctEcuProducer = new FormControl("", [Validators.required, this.duplicateProducerValidator.bind(this)]);
    acceptedEcuProducer = new FormControl("", Validators.required)
    editingText = signal<string>('');
    oldProducerValue = signal<string>("");
    newProducerValue = signal<string>("")
    searchQuery = signal('');
    expandedAcceptedNames = new Set<number>();
    filteredProducers = computed(() => {
        const query = this.searchQuery().trim().toLocaleLowerCase();
        return this.ecuProducersService.correctEcuProducers().filter(producer =>
            !query || [producer.correctEcuProducer, producer.acceptedEcuProducer]
                .some(name => name?.toLocaleLowerCase().includes(query))
        );
    });

    originalIndex(producer: CorrectEcuProducersModel): number {
        return this.ecuProducersService.correctEcuProducers().indexOf(producer);
    }

    acceptedNames(producer: CorrectEcuProducersModel): string[] {
        return (producer.acceptedEcuProducer || '').split(',').map(name => name.trim()).filter(Boolean);
    }

    visibleAcceptedNames(producer: CorrectEcuProducersModel): string[] {
        const names = this.acceptedNames(producer);
        return this.expandedAcceptedNames.has(producer.id) ? names : names.slice(0, 3);
    }

    toggleAcceptedNames(id: number): void {
        if (this.expandedAcceptedNames.has(id)) this.expandedAcceptedNames.delete(id);
        else this.expandedAcceptedNames.add(id);
    }

    ngOnInit() {
        this.resetTableValue();
        this.getCorrectEcuProducers();
    }

    resetTableValue() {
        this.ecuProducersService.resetTableValue();
    }

    getCorrectEcuProducers() {
        this.ecuProducersService.getAllCorrectEcuProducers();
    }

    private duplicateProducerValidator(control: AbstractControl): ValidationErrors | null {
        const name = (control.value as string | null)?.trim().toLowerCase();
        if (!name) {
            return null;
        }

        const exists = this.ecuProducersService.correctEcuProducers().some(
            producer => producer.correctEcuProducer?.trim().toLowerCase() === name
        );
        return exists ? {duplicateProducer: true} : null;
    }

    toggleInputRow(): void {
        if (this.ecuProducersService.showNewInputRow()) {
            this.ecuProducersService.closeRow();
            return;
        }
        this.ecuProducersService.closeEditedItem();
        this.correctEcuProducer.reset('');
        this.acceptedEcuProducer.reset('')
        this.ecuProducersService.toggleNewInputRow();
    }

    deleteItemFromDatabase(id: number) {
        this.ecuProducersService.deleteItemFromDatabase(id);
    }

    toggleEditView(index: number, ecuProducer: CorrectEcuProducersModel) {
        this.ecuProducersService.closeRow();
        this.ecuProducersService.toggleEditView(index);
        this.correctEcuProducer.setValue(ecuProducer.correctEcuProducer || '');
        this.acceptedEcuProducer.setValue(ecuProducer.acceptedEcuProducer || '');

    }

    saveEditedItem(event: Event, oldProducerValue: string) {
        const target = event.target as HTMLInputElement;
        this.newProducerValue.set(target.value);
        this.editingText.set(target.value);
        this.oldProducerValue.set(oldProducerValue);
    }

    editEcuProducer(id: number, element: CorrectEcuProducersModel) {
        const updatedProducer: CorrectEcuProducersModel = {
            id: element.id,
            correctEcuProducer: this.correctEcuProducer.value,
            acceptedEcuProducer: this.acceptedEcuProducer.value
        };

        this.ecuProducersService.editEcuProducer(id, updatedProducer);
    }


    saveNewRow() {
        if (this.correctEcuProducer.invalid || this.acceptedEcuProducer.invalid || this.ecuProducersService.newRowConflict()) {
            return;
        }

        const ecuProducer = {
            id: 0,
            correctEcuProducer: this.correctEcuProducer.value,
            acceptedEcuProducer: this.acceptedEcuProducer.value
        }
        this.ecuProducersService.saveNewRow(ecuProducer);
    }

}
